import { useEffect, useState } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import {
  tableControlBaseClasses,
  tableControlContainerClasses,
} from "./tableControlStyles";

function TableGlobalFilter() {
  const tableContext = useTableCtx()!;

  const { setTableGlobalFilter, globalFilterOptions } = tableContext;

  const [filterTerm, setFilterTerm] = useState<string>("");

  useEffect(() => {
    setTableGlobalFilter && setTableGlobalFilter(filterTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterTerm]);

  if (!globalFilterOptions) {
    return null;
  }

  return (
    <div className={tableControlContainerClasses}>
      {/* begin::Search */}
      <div className="relative flex items-center">
        <select
          name={"select-filter"}
          data-control={"select-filter"}
          data-hide-search="true"
          className={`${tableControlBaseClasses} min-w-[130px] px-3`}
          defaultValue={0}
          onChange={(e) => setFilterTerm(e.target.value)}>
          {globalFilterOptions.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      {/* end::Search */}
    </div>
  );
}

export default TableGlobalFilter;
